import { Component, Input, Output, EventEmitter, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { EncryptedStorageService } from '@elan/services/encrypted-storage.service';
import { ROLES } from '@elan/core/constants/role/role-constants';

interface DropdownGroup {
  title: string;
  icon: string;
  open?: boolean;
  items?: string[];
  link?: string;
  allowedRoles?: string[];
}

import Swal from 'sweetalert2';
@Component({
  imports: [CommonModule, RouterModule],
  selector: 'app-sidebar',
  standalone: true,
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.scss',
})
export class Sidebar {
  @Input() collapsed = false;
  @Output() collapsedChange = new EventEmitter<boolean>();

  constructor(private router: Router, private encryptedStorageService: EncryptedStorageService) { }

  // ngOnInit() {
  //   this.checkScreenSize(true);
  // }

  // @HostListener('window:resize', ['$event'])
  // onResize(event: any) {
  //   this.checkScreenSize(false);
  // }

  // checkScreenSize(isInit: boolean) {
  //   if (window.innerWidth > 767 && this.collapsed) {
  //     this.collapsed = false;
  //     if (!isInit) {
  //     this.collapsedChange.emit(this.collapsed);
  //     }
  //   }
  // }

  dropdowns: DropdownGroup[] = [
    {
      title: 'Appointment',
      icon: 'fa-solid fa-calendar-check',
      link: '/user/appointments',
      allowedRoles: [ROLES.ADMIN, ROLES.MANAGER, ROLES.BILLING_STAFF],
    },
    // {
    //   title: 'Service/ Products',
    //   icon: 'fa-solid fa-scissors',
    //   link: '/user/product-or-service',
    //   allowedRoles: [ROLES.ADMIN, ROLES.MANAGER, ROLES.INVENTORY_STAFF, ROLES.BILLING_STAFF],
    // },
    {
      title: 'Staff',
      icon: 'fa-solid fa-clipboard-user',
      link: '/user/staff',
      allowedRoles: [ROLES.ADMIN, ROLES.MANAGER],
    },
    {
      title: 'Purchase',
      icon: 'fa-solid fa-cart-shopping',
      link: '/user/entry/purchase',
      allowedRoles: [ROLES.ADMIN, ROLES.MANAGER, ROLES.BILLING_STAFF, ROLES.INVENTORY_STAFF],
    },
    {
      title: 'Invoice',
      icon: 'fa-solid fa-file-invoice',
      link: '/user/entry/invoice',
      allowedRoles: [ROLES.ADMIN, ROLES.MANAGER, ROLES.BILLING_STAFF],
    },
    {
      title: 'Customer List',
      icon: 'fa-solid fa-user',
      link: '/user/customerlist',
      allowedRoles: [ROLES.ADMIN],
    },
    {
      title: 'My task',
      icon: 'fa fa-tasks',
      link: '/user/dashboard/view',
      allowedRoles: [ROLES.SERVICE_STAFF],
    },
     {
      title: 'Staff Transfer',
      icon: 'fa-solid fa-clipboard-user',
      link: '/user/staff-transfer',
      allowedRoles: [ROLES.ADMIN, ROLES.MANAGER,ROLES.BILLING_STAFF, ROLES.INVENTORY_STAFF, ROLES.SERVICE_STAFF],
    },
  ];

  /**
   * Get the current user's roles from encrypted storage
   * @returns The user's role names or empty array if not found
   */
  getUserRoles(): string[] {
    const token: any = this.encryptedStorageService.getItem('token');
    if (token && token.data && token.data.user && token.data.user.user_roles) {
      const userRoles = token.data.user.user_roles;
      return userRoles.map((ur: any) => ur.role?.name).filter((name: string) => !!name);
    }
    return [];
  }

  /**
   * Check if the current user has access to a menu item based on allowed roles
   * @param allowedRoles - Array of roles that can access the menu item
   * @returns true if user has access or if no roles are specified, false otherwise
   */
  hasAccess(allowedRoles?: string[]): boolean {
    if (!allowedRoles || allowedRoles.length === 0) {
      return true;
    }
    const userRoles = this.getUserRoles();
    return allowedRoles.some((role) => userRoles.includes(role));
  }

  /**
   * Get filtered list of menu items based on user role
   * @returns Array of visible dropdown groups
   */
  getVisibleMenus(): DropdownGroup[] {
    return this.dropdowns.filter((menu) => this.hasAccess(menu.allowedRoles));
  }

  /**
   * Check if the settings menu should be visible for current user
   * @returns true if user role is Admin or Manager
   */
  canAccessSettings(): boolean {
    const userRoles = this.getUserRoles();
    const allowedSettingsRoles = [
      ROLES.ADMIN,
      ROLES.MANAGER,
      ROLES.INVENTORY_STAFF,
      ROLES.BILLING_STAFF,
    ];
    return allowedSettingsRoles.some((role) => userRoles.includes(role));
  }

  toggleSidebar() {
    this.collapsed = !this.collapsed;
    this.collapsedChange.emit(this.collapsed);
  }

  toggleDropdown(group: DropdownGroup) {
    // close others
    this.dropdowns.forEach((d) => {
      if (d !== group) d.open = false;
    });
    // toggle selected
    group.open = !group.open;
  }
  gotoLink(link: any) {
    this.router.navigate([link]);
  }
  userLogout() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you really want to log out!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, log out it!',
      buttonsStyling: false,
      customClass: {
        confirmButton: 'btn btn-primary popup-btn-color px-4',
        cancelButton: 'btn btn-secondary popup-btn-color ms-2 px-4',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.encryptedStorageService.removeItem('token');
        setTimeout(() => {
          this.router.navigate(['/login']);
        });
      }
    });
  }
}
